<div class="default-font-sizes default-font-sizes--big">Passend dazu</div>
<app-accessory-list
  [articleAccessory]="articleAccessory$ | async"
  (alternativeArticleSelected)="selectArticle($event)"
></app-accessory-list>
